import { AnyAction } from '@reduxjs/toolkit'

import { PayloadActionWithError } from './PayloadActionWithError'

export const isRejected =
  (prefix = '') =>
  (action: AnyAction): action is PayloadActionWithError =>
    action.type?.endsWith('rejected') && action.type?.startsWith(prefix)
